import GanttView from "../../components/Gantt";

const RoadMap = () => {
    return (
        <div className="max-w-[93%] min-w-[80%]">
            <GanttView />
        </div>
    )
}

export default RoadMap;